import { z } from 'zod'
import { DateTime } from 'luxon'

/**
 * Schéma représentant une date de naissance ISO 8601 prenant en entrée :
 * - null
 * - String ISO 8601
 * - Date JS
 */

export const UserBirthdateSchema = z.coerce.date().nullish()
  .refine((value) => {
  if (value === null || value === undefined) return true;
  return DateTime.fromJSDate(value).isValid ? DateTime.fromJSDate(value) < DateTime.now().startOf('day') : false;
  }, { message: 'La date de naissance doit être antérieure à la date du jour.'})
  .transform((value) => {
    if (value === null || value === undefined) return null;
    return DateTime.fromJSDate(value).toISODate();
  })
export type UserBirthdateSchemaEntity = z.infer<typeof UserBirthdateSchema>

/**
 * @Deprecated
 */
export const UserBirthdateISOSchema = z.preprocess((value) => {
  if (value === undefined) return undefined;
  if (value === null || value === '') return null;
  if (value instanceof Date) return DateTime.fromJSDate(value).toISODate();
  if (value instanceof DateTime) return value.toISODate();
  if (typeof value === 'string') return DateTime.fromISO(value).isValid ? value : null;
  return null;
}, z.string().date().nullish()).refine((value) => {
  if (value === null || value === undefined) return true;
  return DateTime.fromISO(value).isValid ? DateTime.fromISO(value) < DateTime.now().startOf('day') : false;
}, { message: 'La date de naissance doit être antérieure à la date du jour.' })

export type UserBirthdateEntity = z.infer<typeof UserBirthdateISOSchema>